
<mat-toolbar color="primary" class="mat-elevation-z3 layout-header">
  <div class="left">
      <img src="assets/logo-1.svg" alt="Logo" class="logo" /><a routerLink="/" class="mms-link">MMS</a>
    <span class="screen-name" *ngIf="headerTitle$ | async as title">
      {{ title }}
    </span>
  </div>
  <span class="spacer"></span>

  <div style="display: contents;">
    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <button mat-button [matMenuTriggerFor]="userMenu" class="avatar">
      {{ profile?.givenName?.charAt(0) }}{{ profile?.surname?.charAt(0) }}
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item>
        <img src="assets/common-img/user.svg" />{{ profile?.givenName }}{{ profile?.surname }}
      </button>
      <button mat-menu-item (click)="logout()"><img src="assets/common-img/logout.svg" /> Logout</button>
    </mat-menu>
    <div>
    </div>
    <button mat-icon-button class="menu-icon-btn" (click)="toggleSidenav.emit()">
      <img src="assets/sidebar/menu-icon.svg" alt="Menu" />
    </button>
  </div>
